import { currentCoachName } from './currentCoachName'

export const attributionStamp = (): { submittedBy: string; submittedAt: string } => ({
  submittedBy: currentCoachName(),
  submittedAt: new Date().toISOString(),
})
